import CryptoJS from "crypto-js";
import { ivs_key, secret_key } from "../config";

export const AesEncrypt = async (data) => {
  const key = await CryptoJS.enc.Hex.parse(secret_key); // 128-bit key
  const iv = await CryptoJS.enc.Hex.parse(ivs_key); // 128-bit IV

  // Decrypt the data using AES-CBC
  const encryptedData = await CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const enryptedData = await encryptedData.toString();

  return enryptedData;
};
